import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserDetailsServiceService } from './user-details-service.service';

@Component({
  selector: 'app-view-user-details',
  templateUrl: './view-user-details.component.html',
  styleUrls: ['./view-user-details.component.sass']
})
export class ViewUserDetailsComponent implements OnInit {

userId:any;
userDetail:any

  constructor(public activatedRoute: ActivatedRoute,
              private spinner : NgxSpinnerService,
              private router: Router,
              private toastr:ToastrService,  private userDetailService:UserDetailsServiceService ) { }
             
  ngOnInit(): void {
    this.userId=this.activatedRoute.snapshot.queryParams.id;
    console.log(this.userId)
    this.getUserDetailsById()
  }

  getUserDetailsById(){
    let data = {
       "id" : this.userId
    }
    this.spinner.show();
    this.userDetailService.userByID(data).subscribe((result:any)=>{
      console.log(result)
      if(result.statusCode == 200){
        this.spinner.hide()
        this.userDetail = result.data;
      }else{
        this.spinner.hide()
        this.toastr.error(result.message);
      }
    })

  }







  back(){
    this.router.navigateByUrl('dashboard/users')
  }
}
